import { Route } from '@angular/router';
import { AuthGuard, nonAuthGuard } from '@angular-monorepo/auth';
import { AuthenticatedLayoutComponent, NotFoundAuthenticatedComponent } from '@angular-monorepo/ui';
import { DitrackLoginComponent } from './pages/login/ditrack-login.component';

export const appRoutes: Route[] = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'login',
  },
  {
    path: 'login',
    canActivate: [nonAuthGuard],
    component: DitrackLoginComponent,
  },
  {
    path: 'invitation/:token',
    loadComponent: () =>
      import('@angular-monorepo/ditrack').then(
        (m) => m.InvitationComponent
      ),
  },
  {
    path: 'accept-invitation',
    loadComponent: () =>
      import('@angular-monorepo/ditrack').then(
        (m) => m.AcceptInvitationComponent
      ),
  },
  {
    path: 'auth/callback',
    loadComponent: () =>
      import('./pages/auth-callback/auth-callback.component').then(
        (m) => m.AuthCallbackComponent
      ),
  },
  {
    path: 'onboarding',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('@angular-monorepo/ditrack').then(
        (m) => m.OnboardingComponent
      ),
  },
  {
    path: 'workspace-selector',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('@angular-monorepo/ditrack').then(
        (m) => m.WorkspaceSelectorComponent
      ),
  },
  {
    path: '',
    component: AuthenticatedLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'tiempo/my-time',
      },
      {
        path: 'dashboard',
        redirectTo: 'tiempo/my-time',
      },
      {
        path: '',
        loadChildren: () =>
          import('@angular-monorepo/ditrack').then((m) => m.DITRACK_ROUTES),
      },
      {
        path: 'not-found',
        component: NotFoundAuthenticatedComponent,
      },
      {
        path: '**',
        redirectTo: 'not-found',
      },
    ],
  },
];